import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

const FeeDialog = ({
  visible,
  onHide,
  editing,
  feeForm,
  setFeeForm,
  saveFee,
  feeTypeOptions,
  classes
}) => {
  const footer = (
    <div className="flex justify-between items-center mt-4">
      <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="bg-black text-white rounded-lg px-4 py-2 hover:bg-gray-900 transition-all" />
      <Button label={editing ? 'Update' : 'Create'} icon="pi pi-check" onClick={saveFee} className="px-6 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 font-medium shadow-lg hover:shadow-xl" />
    </div>
  );

  return (
    <Dialog header={editing ? 'Edit Fee Structure' : 'Add Fee Structure'} visible={visible} onHide={onHide} style={{ width: '600px' }}
      footer={footer} className="rounded-2xl">
      <div className="space-y-6 p-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800 flex items-center"><i className="mr-2 text-blue-600"></i>Fee Type *</label>
            <Dropdown value={feeForm.feeType}
              options={feeTypeOptions.filter(opt => opt.value !== '')} onChange={(e) => setFeeForm({ ...feeForm, feeType: e.value })} placeholder="Select Fee Type"
              className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800 flex items-center">
              <i className="mr-2 text-green-600"></i>Amount *
            </label>
            <InputText value={feeForm.amount} onChange={(e) => setFeeForm({ ...feeForm, amount: e.target.value.replace(/\D/g, '') })}
              placeholder="Enter amount" className="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all duration-200 bg-white shadow-sm" />
          </div>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-semibold text-gray-800 flex items-center">
            <i className="pi pi-book mr-2 text-purple-600"></i> Class
          </label>
          <Dropdown value={feeForm.classId} options={classes.map(c => ({ label: c.name || c.className, value: c.id }))}
            onChange={(e) => setFeeForm({ ...feeForm, classId: e.value })} placeholder="Select Class" className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-semibold text-gray-800 flex items-center">
            <i className="pi pi-info-circle mr-2 text-indigo-600"></i> Description
          </label>
          <InputText value={feeForm.description} onChange={(e) => setFeeForm({ ...feeForm, description: e.target.value })}
            placeholder="Enter description" className="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white shadow-sm" />
        </div>
      </div>
    </Dialog>
  );
};

export default FeeDialog;
